<template>
  <eagle-form
    :form-key="formKey"
  ></eagle-form>
</template>

<script lang="babel" type="text/babel">
import formMixin from '@/components/form/mixins/formMixin'
import formConfig from './pageFormConfig'
export default {
  mixins: [formMixin],
  data: () => ({
    formKey: 'page-form',
    meta: {},
  }),
  mounted() {
    this.meta.loadCategories = this.loadCategories
  },
  methods: {
    async beforeFormInit() {
      await Promise.all([
        this.loadCategories(),
      ])
    },
    async loadCategories() {
      let result = null
      try {
        result = await this.$api.collection.pageCategoryApi.flatTree(this.pageType)
      } catch (error) {
        console.warn(error)
      }

      this.meta.depthOfType = result.depth_of_type
      this.meta.categories = result.nodes
      return result
    },
    validateBeforeSave() {
      // TODO
    },
    async readApi(target) {
      return await this.$api.collection.pageApi.read(target)
    },
    async createApi(formData) {
      return await this.$api.collection.pageApi.create(formData)
    },
    async updateApi(target, formData) {
      return await this.$api.collection.pageApi.update(target, formData)
    },
    async deleteApi(target) {
      return await this.$api.collection.pageApi.delete(target)
    },
    getFormConfig() {
      return formConfig
    },
  },
  computed: {
    frontendDomain() {
      return this.$store.getters['base/eagleEnv'].frontendDomain
    },
    pageType() {
      return this.$route.meta.type
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
